import entityApiUrl from '../entity/baseUrl'
import fetchAuthorized from '../authorization/fetchAuthorized'
import { VersionRecord } from '../entity/data/listVersions'
import { RegistryAsset } from './listRegistryAssets'

export type RegistryAssetDetail = RegistryAsset & {
  versions: VersionRecord[]
}

const getRegistryAsset = async (entityId: string): Promise<RegistryAssetDetail> => {
  const response = await fetchAuthorized(`${entityApiUrl}/registry/assets/${entityId}`, {
    method: 'GET',
  })
  if (response.status !== 200) {
    throw Error(`Unexpected response code ${response.status} from getRegistryAsset endpoint`)
  }
  return (await response.json()) as RegistryAssetDetail
}

export default getRegistryAsset
